module.exports = __webpack_public_path__ + "static/portfolio-3-d4605df5b0c3f2c4b009408285366aa9.jpg";